module.exports = __webpack_public_path__ + "static/media/news.ef8d922c.png";